export const handleChangeKeyValue = (tableData, uniqId, rowKey, value) => {
  const newTableData = [...tableData];
  newTableData.forEach(v => {
    if (v.uniqId === uniqId) {
      v[rowKey] = value
    }
  })
  return newTableData
}

export const handleDeleteRow = (tableData, uniqId) => {

  let newTableData = [...tableData];
  newTableData = newTableData.filter(v => v.uniqId !== uniqId)
  return newTableData
}
export const sumEachRow = (tableData) => {
  debugger
  let newTableData = [...tableData];
  newTableData = newTableData.map(v => {
    v.sum = (+v.weight) * (+v.price)

    return v
  })
  return newTableData
}